import {
  NBS_API_CONFIRM_EMAIL_REQUEST,
  NBS_API_CONFIRM_EMAIL_SUCCESS,
  NBS_API_CONFIRM_EMAIL_FAILURE
} from '../../constants/actions';
import { deviceId } from '../../assets/helpers/utils';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiConfirmEmailRequest () {
  return { type: NBS_API_CONFIRM_EMAIL_REQUEST };
}
function nbsApiConfirmEmailSuccess (response) {
  return {
    type: NBS_API_CONFIRM_EMAIL_SUCCESS,
    response
  };
}
function nbsApiConfirmEmailError (error) {
  return {
    type: NBS_API_CONFIRM_EMAIL_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiConfirmEmail (data) {
  data.device_id = deviceId();
  const url = 'confirmEmail';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiConfirmEmailRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiConfirmEmailSuccess(response)))
      .catch(error => dispatch(nbsApiConfirmEmailError(error)));
  };
}
